/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CardType {
    Virtual = 'VIRTUAL',
    Physical = 'PHYSICAL',
    Both = 'BOTH'
}

export function CardTypeFromJSON(json: any): CardType {
    return CardTypeFromJSONTyped(json, false);
}

export function CardTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardType {
    return json as CardType;
}

export function CardTypeToJSON(value?: CardType | null): any {
    return value as any;
}

